<template>
    <li :class="[cssClass, 'list-group-item', 'executor']" @click="highlight">
        <strong>{{ executor.agent.name }}</strong>
        <span class="badge" title="Number of performed instructions" data-toggle="tooltip" data-placement="top">{{ executor.elapsedSteps }}</span>
        <span class="badge" title="Current penalty for instruction cost" v-show="executor.penalty >= 1">Penalty: {{ executor.penalty }}</span>
        <div class="instructions">
            <div class="instruction instruction-last" v-if="executor.last">[{{ executor.lastIp }}] {{ executor.last.id }}</div>
            <div :class="['instruction', 'instruction-next', { 'instruction-highlight': next }]" v-if="executor.next">[{{ executor.ip }}] {{ executor.next.id }}</div>
        </div>
        <div v-if="executor.error" :title="executor.error.message" class="error-msg"><small><icon name="warning"/> Runtime error!</small></div>
    </li>
</template>

<script>

    export default {
        name: "executor",
        props: ["executor", "next", "last"],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
            highlight() {
                this.executor.highlight();
            }
        },
        watch: {
        },
        components: {
        },
        computed: {
            cssClass() {
                if (this.executor.error) {
                    return "executor-error";
                } else if (this.executor.done) {
                    return "executor-done";
                } else if (this.next) {
                    return "executor-next";
                } else if (this.last) {
                    return "executor-last";
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import '~src/less/index.less';
    
    .executor {
        cursor: pointer;
    }
    
    .instructions {
        display: table;
        width: 100%;
    }

    .instruction {
        display: inline-block;
        width: 50%;
        float: left;
        font-size: small;
        white-space: nowrap;
        overflow: hidden;
    }
    .instruction-next {
        font-style: bold;
    }
    .instruction-last {
        opacity: 0.5;
    }
    .instruction-highlight {
        color: white;
        background-color: @info-color;
    }

    .executor-error {
        color: @error-color;
        background-color: @error-bg;
    }
    .executor-next {
        color: @info-color;
        background-color: @info-bg;
    }
    .executor-last {
        color: @info-color;
        background-color: @info-bg;
        opacity: 0.5;
    }
    .executor-done {
        color: @success-color;
        background-color: @success-bg;
    }
</style>


// WEBPACK FOOTER //
// Executor.vue?61d01d04